<template>
  <div class="tabs_content" id="tab-2">
    <section>
      <a
          :data-title="$gettext('Přenačíst historii zařízení')"
          class="tab_button tab_button_refresh title_tooltip"
          @click.stop="_reloadDeviceEntity"
      />

      <div class="status">
        <h2 v-translate>Historie zařízení</h2>
      </div>
      <div class="scroll-wrapper">
        <div class="table_overflow" id="contentBox" data-table-id="devices-history">
          <table class="vypis">
            <not-sorting-table-header
                v-if="entity.device_history.length > 0"
                :titles="deviceHistoryTableTitles"
                :useRight="false"
                :checkbox="true"
                :dragDrop="true"
            />
            <tbody>
            <device-history-row
                v-for="entity in entity.device_history"
                :entity="entity"
                :key="entity.id"
                :selectedEntities="selectedEntities"
                @input="select"
            />
            <tr v-if="entity.device_history.length === 0">
              <td :colspan="deviceHistoryTableTitles.length" v-translate>Neexistuje žádný záznam o historii zařízení.
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <local-list-action-line
          :entities="entity.device_history"
          :selected-entities="selectedEntities"
          :multiple-action-options="multipleActionOptions"
          table-id="devices-history"
          @select-all="toggleSelectAll"
          @run-multiple-action="runMultipleAction"
      ></local-list-action-line>
    </section>
  </div>
</template>

<script>
import DeviceHistoryRow from "./DeviceHistoryRow.vue";
import NotSortingTableHeader from "@/components/common/NotSortingTableHeader"
import localTable from "@/components/mixins/local-table"

export default {
    name: "DeviceHistory",
    components: {DeviceHistoryRow, NotSortingTableHeader},
    mixins: [localTable],
    props: {
        entity: Object,
    },
    created(DeviceService) {
        this.deviceService = DeviceService
    },
    methods: {
        _reloadDeviceEntity() {
            this.$emit('reloadEntity');
        },
    },
    computed: {
        entities(){
          return Object.values(this.entity.device_history);
        },
        csvHeaders(){
          return {
            'firmware': {name: this.$gettext('Firmware')},
            'application': {name: this.$gettext('Aplikace')},
            'device_profile': {name: this.$gettext('Profil zařízení')},
            'device_type': {name: this.$gettext('Typ zařízení')},
            'timestamp_created': {name: this.$gettext('Datum změny')},
          }
        },
        deviceHistoryTableTitles() {
            return [
                this.$gettext('Firmware'),
                this.$gettext('Aplikace'),
                this.$gettext('Profil zařízení'),
                this.$gettext('Typ zařízení'),
                this.$gettext('Datum změny')
            ]
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/views/devices/detail/DeviceHistory.vue